import VideoPlayer from './VideoPlayer';

export default class Video {
	constructor() {
		document.addEventListener('bless', () => {
			this.init();
		});
	}

	init() {
		const videos = document.querySelectorAll('.m-video');

		videos.forEach(video => {
			this.videoPlayer = new VideoPlayer(video);
            this.videoPlayer.init();
		});
	}
}
